// assets
import {
  DashboardOutlined,
  BellOutlined,
  MessageOutlined,
} from "@ant-design/icons";

// icons
const icons = {
  DashboardOutlined,
  BellOutlined,
  MessageOutlined,
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: "group-dashboard",
  type: "group",
  children: [
    {
      id: "dashboard",
      title: "Dashboard",
      type: "item",
      url: "/dashboard",
      icon: icons.DashboardOutlined,
      breadcrumbs: false,
    },
    {
      id: "notifications",
      title: "Notifications",
      type: "item",
      url: "/dashboard/notifications",
      icon: icons.BellOutlined,
      breadcrumbs: false,
    },
    {
      id: "contactus",
      title: "Contact Us",
      type: "item",
      url: "/dashboard/contactus",
      icon: icons.MessageOutlined,
      breadcrumbs: false,
    },
  ],
};

export default dashboard;
